import React, { useState, useEffect, useCallback } from "react";
import { Redirect, useHistory } from "react-router-dom";
import axios from "react-axios";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

import Container from "react-bootstrap/Container";
import { DraggableCard } from "./DraggableCard"
import Button from "react-bootstrap/Button";
import Alert from "react-bootstrap/Alert";
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'

import { useUser } from "~/Context/userContext";
import TrackImage from "~/Components/Elements/Global/TrackImage";
import PlaylistEditForm from "./PlaylistEditForm";
import { getPlaylist, postPlaylistDelete, postPlaylistTrackDelete, postPlaylistSort } from "~/api/getCustomPlaylists";
import update from 'immutability-helper';

import "./Playlists.less";

const PlaylistEdit = ({ match }) => {
  const { state: userState } = useUser();
  const [loading, setLoading] = useState(true);
  const [savingDrop, setSavingDrop] = useState(false);
  const [playlist, setPlaylist] = useState({});
  const [tracks, setTracks] = useState([]);
  const [error, setError] = useState(false);
  let history = useHistory();

  const playlistId = match.params.playlistId;

  function handleCancelClick() {
    history.push(`/playlist/${match.params.playlistId}`);
  }
  const handleDeleteClick = async (trackId) => {
    const resp = await postPlaylistTrackDelete(axios, { playlistId, trackId });
    console.log("🚀 ~ file: PlaylistEdit.js:34 ~ handleDeleteClick ~ resp:", resp);
    if (resp.status === 200) {
      load();
    } else {
      setError(true);
    }
  };
  const handleDeletePlaylistClick = async () => {
    if (window.confirm("Are you sure?")) {
      const resp = await postPlaylistDelete(axios, { playlistId });
      console.log("🚀 ~ file: PlaylistEdit.js:46 ~ handleDeletePlaylistClick ~ resp:", resp);
      history.push(`/profile/${userState.user.dir}/playlists`);
    }
  };
  const onComplete = () => {
    history.push(`/playlist/${match.params.playlistId}`);
  };
  const load = async () => {
    const resp = await getPlaylist(axios, playlistId);
    setPlaylist(resp.data);
    setTracks(resp.data.tracks);
    setLoading(false);
  };
  useEffect(() => {
    load();
  }, []);

  const moveCard = useCallback(
    (dragIndex, hoverIndex) => {
      const dragCard = tracks[dragIndex];
      setTracks(
        update(tracks, {
          $splice: [
            [dragIndex, 1],
            [hoverIndex, 0, dragCard],
          ],
        }),
      )
    },
    [tracks],
  )

  const hasDropped = async () => {
    setSavingDrop(true)
    const resp = await postPlaylistSort(axios, { playlistId, tracks: JSON.stringify(tracks) });
    setSavingDrop(false)
  }

  if (!loading && playlist.userDir && userState.loaded && playlist.userDir !== userState.user.dir) {
    return <Redirect to={`/`} />;
  }

  return (
    <div className="genre-page-component">
      <React.Fragment>
        {loading ? (
          <div>Loading</div>
        ) : (
          <>
            <Row>
              <Col xs={12}>
                <div className="page-header">
                  <h2>Edit Playlist</h2>
                </div>

                <div style={{ margin: "20px 0" }}>
                  <p>Edit the details about your playlist here.</p>
                </div>
              </Col>
            </Row>
            <Row className="">
              <Col xs={12}>
                <Col xs={12}>
                  <div className="trackDetailsEditForm">
                    <PlaylistEditForm playlist={playlist} onComplete={onComplete} />
                  </div>
                </Col>
                {error && <Alert variant="danger">Strange Error: Please reload and try again.</Alert>}

                <Col xs={12}>
                  <hr />
                  <h2>Playlist Tracks</h2>
                  <p>{tracks && tracks.length > 1 && `Drag and drop to re-order the tracks. `}
                    Click the (x) to remove a track from the playlist. <strong>Changes below will be saved automatically.</strong></p>
                  <p></p>

                  <div style={{ height: 20 }}>{savingDrop && (<FontAwesomeIcon icon={faSpinner} spin />)}</div>

                  <DndProvider backend={HTML5Backend}>
                    <Container className="p-3" style={{ width: "90%" }} align="center">

                      <div style={{ position: 'relative' }}>
                        <div className={`${savingDrop ? 'playlistSortCover' : ""}`}></div>
                        {tracks.map((track, index) => (
                          <DraggableCard key={track.id} index={index} id={track.id} moveCard={moveCard} playlistId={playlistId} track={track} hasDropped={hasDropped} handleDeleteClick={handleDeleteClick} />
                        ))}
                      </div>

                    </Container>
                  </DndProvider>
                </Col>
                <Col xs={12} style={{ textAlign: "left" }}>
                  <Button variant="primary" onClick={() => handleCancelClick()}>
                    Done
                  </Button>
                </Col>
                <Col xs={12} style={{ textAlign: "right", marginTop: 60 }}>
                  <Button variant="danger" size="sm" onClick={() => handleDeletePlaylistClick()}>
                    Delete Playlist
                  </Button>
                </Col>
              </Col>
              <Col xs={12} sm={6} lg={4}></Col>
            </Row>
            <Row className="divider"></Row>
          </>
        )}
      </React.Fragment>
    </div >
  );
};

export default PlaylistEdit;
